import { useEffect, useState } from 'react';

export type ResponsiveViewport =
  | 'phone'
  | 'tablet-portrait'
  | 'tablet-landscape'
  | 'desktop'
  | 'wide';

function resolveViewport(width: number): ResponsiveViewport {
  if (width < 768) {
    return 'phone';
  }
  if (width < 1024) {
    return 'tablet-portrait';
  }
  if (width < 1280) {
    return 'tablet-landscape';
  }
  if (width < 1536) {
    return 'desktop';
  }
  return 'wide';
}

export function useResponsiveViewport() {
  const [viewport, setViewport] = useState<ResponsiveViewport>(() => {
    if (typeof window === 'undefined') {
      return 'desktop';
    }
    return resolveViewport(window.innerWidth);
  });

  useEffect(() => {
    const handleResize = () => {
      setViewport(resolveViewport(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    viewport,
    isPhone: viewport === 'phone',
    isTablet: viewport === 'tablet-portrait' || viewport === 'tablet-landscape',
    isTabletPortrait: viewport === 'tablet-portrait',
    isTabletLandscape: viewport === 'tablet-landscape',
    isDesktop: viewport === 'desktop' || viewport === 'wide',
    isWide: viewport === 'wide',
  };
}
